import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Accordion,
  Alert,
  Badge,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  Table,
  Tabs,
  TabItem,
  Spinner,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES, QUERIES, USERS } from "../../config/apiConfig";
import { formatToReal, isOlderThan30Days } from "../../utils/utils";
import { IoIosCheckmarkCircleOutline, IoMdSearch } from "react-icons/io";
import AutoCompleteInput from "../inputs/Autocomplete";
import EmptyTable from "./EmptyTable";
import {
  MdEdit,
  MdErrorOutline,
  MdOutlineAttachMoney,
  MdOutlineDisplaySettings,
  MdOutlinePageview,
  MdPersonSearch,
  MdReceiptLong,
} from "react-icons/md";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import axiosInstance from "../../config/axiosInstance";
import { useApplication } from "../../contexts/ApplicationContext";
import { Tooltip } from "react-tooltip";
import { useReactToPrint } from "react-to-print";
import CustomCreditQueryReview from "../queries/CustomCreditQueryReview";
import CustomVehicleQueryReview from "../queries/CustomVehicleQueryReview";
import { LuFilter, LuFilterX } from "react-icons/lu";
import ModalEditPrice from "../modals/ModalEditPrice";
import TableLoading from "../TableLoading";
import { FaMoneyBillWave } from "react-icons/fa";
import CustomCadastralQueryReview from "../queries/CustomCadastralQueryReview";

const AdminHistoryTableSpecific = ({ companyId, isActive }) => {
  const { user } = useApplication();
  const queryClient = useQueryClient();
  const { userPermission } = useApplication();

  const [activeTab, setActiveTab] = useState(1);
  const [activeTabModal, setActiveTabModal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);

  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [listCategoryQueries, setListCategoryQueries] = useState([]);
  const [openModalViewDetails, setOpenModalViewDetails] = useState(false);
  const reportRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef: reportRef });
  const [openModal, setOpenModal] = useState(false);
  const [dataQuery, setDataQuery] = useState(null);
  const [selectedQueryReview, setSelectedQueryReview] = useState(null);
  const handleCloseReviewModal = () => {
    setOpenModal(false);
    setSelectedQueryReview(null);
    setDataQuery(null);
  };
  const printRef = useRef();
  const reactToPrintFnQuery = useReactToPrint({ contentRef: printRef });

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedIsModular, setSelectedModular] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loadingDownload, setLoadingDownload] = useState(null);
  const [activeIndexLoading, setActiveIndexLoading] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);
  const [editPriceModalOpen, setEditPriceModalOpen] = useState(false);
  const [queryToEdit, setQueryToEdit] = useState(null);
  const [newPrice, setNewPrice] = useState("");
  const [barMetric, setBarMetric] = useState("count"); // 'count' | 'value'
  const [openCostModal, setOpenCostModal] = useState(false);
  const [protocolForCost, setProtocolForCost] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState({
    label: "Todos os produtos",
    value: 0,
  });
  const [selectedUserId, setSelectedUserId] = useState("");

  // NOVO: filtro "É adicional?" (padrão: false)
  const [filterIsAdditional, setFilterIsAdditional] = useState(false);
  const [filterHasIA, setFilterHasIA] = useState(false);

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true);
    } else {
      const timeout = setTimeout(() => setRenderFilters(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const {
    isLoading: isLoadingQueryPermissions,
    error: errorQueryPermissions,
    data: userQueryPermissions,
  } = useQuery(
    ["userQueryPermissions"],
    async () => {
      const { data: items } = await axios.get(
        `${USERS.GET_USER_QUERY_PERMISSIONS}`
      );
      return items?.data?.map((query) => query.id);
    },
    { enabled: isActive }
  );

  const {
    isLoading: isLoadingUsers,
    error: errorUsers,
    data: users,
  } = useQuery(
    ["users"],
    async () => {
      const { data: items } = await axios.get(
        `${ADMIN.GET_USERS}?itemsPerPage=-1&companyId=${companyId}`
      );
      return items.data.data;
    },
    { enabled: isActive }
  );

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(
    ["categories", currentPage],
    async () => {
      const { data } = await axios.get(`${CATEGORIES.GET_ALL}`);
      return data.data.data;
    },
    { enabled: isActive }
  );

  const { isLoading: isLoadingProviders, data: providers } = useQuery(
    ["providers"],
    async () => {
      const { data: items } = await axios.get(`${ADMIN.GET_PROVIDERS_ALL}`);
      return items.data;
    },
    { enabled: activeTabModal === 1 }
  );

  const {
    isLoading: isLoadingQueries,
    error: errorQueries,
    data: listQueries,
  } = useQuery(
    ["listQueries"],
    async () => {
      try {
        const { data } = await axios.get(`${ADMIN.GET_QUERIES_LIST}`);
        if (!data?.data) throw new Error("Erro ao buscar produtos");
        let customers = data.data.map((customer) => ({
          label: customer.name,
          value: customer.id,
        }));
        customers = [{ label: "Todos os produtos", value: 0 }, ...customers];
        return customers;
      } catch (error) {
        throw new Error(`Erro ao buscar produtos: ${error.message}`);
      }
    },
    { enabled: isActive }
  );

  const providerNameById = (id) =>
    providers?.find((p) => p.id === id)?.name || (id ? `ID ${id}` : "-");

  const appliedFilterSummary = useMemo(() => {
    const items = [];
    if (selectedProduct?.value && selectedProduct?.value !== 0) {
      items.push(`Produto: ${selectedProduct?.label || "-"}`);
    }
    if (startDate || endDate) {
      const startLabel = startDate
        ? moment(startDate).format("DD/MM/YYYY")
        : "—";
      const endLabel = endDate ? moment(endDate).format("DD/MM/YYYY") : "—";
      items.push(`Período: ${startLabel} a ${endLabel}`);
    }
    if (selectedStatuses.length > 0) {
      const labels = selectedStatuses
        .map((s) => (s === 1 ? "Sucesso" : "Falha"))
        .join(", ");
      items.push(`Status: ${labels}`);
    }
    if (selectedUserId) {
      const userMatch = (users || []).find(
        (u) => String(u.id) === String(selectedUserId)
      );
      items.push(
        `Usuário: ${userMatch?.name || userMatch?.email || selectedUserId}`
      );
    }
    if (filterIsAdditional) {
      items.push("Adicionais");
    }
    if (filterHasIA) {
      items.push("Somente com IA");
    }
    if (nameParam) {
      items.push(`Busca: ${nameParam}`);
    }
    return items;
  }, [
    selectedProduct?.value,
    selectedProduct?.label,
    startDate,
    endDate,
    selectedStatuses,
    selectedUserId,
    users,
    filterIsAdditional,
    filterHasIA,
    nameParam,
  ]);
  const hasActiveFilters = appliedFilterSummary.length > 0;

  const {
    isLoading: isLoadingReportQueries,
    error: errorListReportQueries,
    data: listReportQueries,
  } = useQuery(
    [
      "listReportQueries",
      companyId,
      startDate,
      endDate,
      currentPage,
      selectedProduct,
      selectedStatuses,
      nameParam,
      selectedUserId,
      filterIsAdditional,
      filterHasIA,
    ],
    async () => {
      const { data } = await axios.get(
        `${
          ADMIN.GET_COMPANY_QUERIES_HISTORY
        }/${companyId}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${
          selectedProduct?.value
        }&search=${nameParam}&isModular=${false}&userId=${selectedUserId}&isAdditional=${
          filterIsAdditional ? "true" : "false"
        }${filterHasIA ? "&hasIA=true" : ""}`
      );
      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalPriceSum);
      setTotalCount(data.data.totalCount);
      return data.data.data;
    },
    { enabled: activeTab === 0 && isActive }
  );

  const { data: listReportQueriesAdditional } = useQuery(
    [
      "listReportQueriesAdditional",
      companyId,
      startDate,
      endDate,
      selectedProduct,
      selectedStatuses,
      nameParam,
      selectedUserId,
    ],
    async () => {
      const { data } = await axios.get(
        `${
          ADMIN.GET_COMPANY_QUERIES_HISTORY
        }/${companyId}?startDate=${startDate}&endDate=${endDate}&page=1&itemsPerPage=-1&status=${selectedStatuses}&queries=${
          selectedProduct?.value
        }&search=${nameParam}&isModular=${false}&userId=${selectedUserId}&isAdditional=true`
      );
      return data.data.data;
    },
    {
      enabled: activeTab === 0 && isActive && !filterIsAdditional,
      keepPreviousData: true,
    }
  );

  const additionalByProtocol = useMemo(() => {
    const map = new Map();
    const rows = Array.isArray(listReportQueriesAdditional)
      ? listReportQueriesAdditional
      : [];

    rows.forEach((row) => {
      const protocol = String(row?.protocol || "").trim();
      if (!protocol) return;
      const name = row?.queryName || row?.name;
      if (!name) return;
      const set = map.get(protocol) || new Set();
      set.add(name);
      map.set(protocol, set);
    });

    return map;
  }, [listReportQueriesAdditional]);

  const {
    isLoading: isLoadingReportSimplifiedQueries,
    error: errorListReportSimplifiedQueries,
    data: listReportSimplifiedQueries,
  } = useQuery(
    [
      "listReportSimplifiedQueries",
      companyId,
      startDate,
      endDate,
      currentPage,
      selectedProduct,
      selectedStatuses,
      selectedUserId,
      filterIsAdditional, // refetch ao mudar o filtro
      filterHasIA,
    ],
    async () => {
      const { data } = await axios.get(
        `${
          ADMIN.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED
        }/${companyId}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${
          selectedProduct?.value
        }&isModular=${false}&userId=${selectedUserId}&isAdditional=${
          filterIsAdditional ? "true" : "false"
        }${filterHasIA ? "&hasIA=true" : ""}`
      );
      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalSumPrice || 0);
      setTotalCount(data.data.totalSumCount);
      return data.data.data;
    },
    { enabled: activeTab === 1 && isActive }
  );

  const {
    isLoading: isLoadingQueryDetails,
    error: errorQueryDetails,
    data: queryDetails,
  } = useQuery(
    ["queryDetails", selectedQuery],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_QUERY_DETAILS}/${selectedQuery?.id}`
        );
        return data.data;
      } catch (error) {
        throw new Error(`Erro ao buscar consulta: ${error.message}`);
      }
    },
    { enabled: isActive && !!selectedQuery }
  );

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [
    activeTab,
    startDate,
    endDate,
    selectedProduct,
    selectedStatuses,
    selectedUserId,
    filterIsAdditional, // volta p/ pág 1 quando alternar o filtro
    filterHasIA,
  ]);

  useEffect(() => {
    setListCategoryQueries(() =>
      categories?.map((category) => {
        return {
          ...category,
          Queries: category?.Queries?.filter((query) =>
            userQueryPermissions?.includes(query.id)
          ),
        };
      })
    );
  }, [userQueryPermissions, categories]);

  const handleDownloadDetails = async (
    index,
    fileName,
    queryId,
    data,
    parameter
  ) => {
    setLoadingDownload(true);
    setActiveIndexLoading(index);

    try {
      const dataFile = await axiosInstance.post(QUERIES.GENERATE_PDF, {
        parameter,
        queryId,
        data: JSON.stringify(data),
        token: localStorage.getItem("token"),
      });

      const url = dataFile.data.data;

      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Erro ao iniciar o download:", error);
    } finally {
      setLoadingDownload(false);
      setActiveIndexLoading(null);
    }
  };

  const Info = ({ label, value }) => (
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );

  const labelize = (key = "") =>
    String(key)
      .replace(/[_-]/g, " ")
      .replace(/\b\w/g, (m) => m.toUpperCase());

  // -------- Parse/normalização seguros do `additional` --------
  const additional = useMemo(() => {
    const raw = queryDetails?.userQuery?.data?.additional;
    if (raw == null) return null;

    let parsed = raw;
    try {
      if (typeof raw === "string") {
        const trimmed = raw.trim();
        if (!trimmed || trimmed === "null" || trimmed === "undefined") {
          return null;
        }
        parsed = JSON.parse(trimmed);
      }
    } catch (e) {
      console.error("Erro ao parsear `additional`:", e, raw);
      return null;
    }

    if (Array.isArray(parsed)) return parsed;
    if (typeof parsed === "object") return parsed;
    return null;
  }, [queryDetails?.userQuery?.data?.additional]);

  // -------- Painéis principais --------
  const { panelsMain, panelsAdditional } = useMemo(() => {
    const data = queryDetails?.userQuery?.data;
    const _panelsMain =
      !data || typeof data !== "object"
        ? []
        : Object.entries(data)
            .filter(
              ([key]) =>
                !["statusRetorno", "resumoRetorno", "additional"].includes(key)
            )
            .map(([key, item], i) => {
              if (!item) return null;
              return (
                <Accordion.Panel key={`main-${i}`}>
                  <Accordion.Title className="text-sm font-medium">
                    <div className="flex justify-between items-center w-full gap-2">
                      <span className="text-gray-800">{key}</span>
                      {item?.statusRetorno === 1 ? (
                        <Badge color="success" className="text-xs">
                          ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                        </Badge>
                      ) : (
                        <Badge color="failure" className="text-xs">
                          ❌ Falha
                        </Badge>
                      )}
                    </div>
                  </Accordion.Title>
                  <Accordion.Content>
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                      <div>
                        <p>
                          <strong>Provedor utilizado:</strong>{" "}
                          {providerNameById(item?.providerId)}{" "}
                          {item?.provedorReserva && "(reserva)"}
                        </p>
                      </div>

                      {Array.isArray(item?.errosAnteriores) &&
                        item.errosAnteriores.length > 0 && (
                          <div className="space-y-2">
                            <p className="font-semibold text-red-800">
                              Tentativas anteriores com erro:
                            </p>
                            {item.errosAnteriores.map((err, idx) => (
                              <div
                                key={idx}
                                className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                              >
                                <p>
                                  <strong>Provedor:</strong>{" "}
                                  {providerNameById(err?.providerId)}
                                </p>
                                <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                                  {err?.message}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                      <div>
                        <p className="font-semibold">Dados retornados:</p>
                        <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                          {JSON.stringify(item, null, 2)}
                        </pre>
                      </div>
                    </div>
                  </Accordion.Content>
                </Accordion.Panel>
              );
            })
            .filter(Boolean);

    const _panelsAdditional = !additional
      ? []
      : Array.isArray(additional)
      ? additional
          .map((item, i) => {
            if (!item) return null;
            return (
              <Accordion.Panel key={`add-arr-${i}`}>
                <Accordion.Title className="text-sm font-medium">
                  <div className="flex justify-between items-center w-full gap-2">
                    <span className="text-gray-800">Adicional {i + 1}</span>
                    {item?.statusRetorno === 1 ? (
                      <Badge color="success" className="text-xs">
                        ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                      </Badge>
                    ) : (
                      <Badge color="failure" className="text-xs">
                        ❌ Falha
                      </Badge>
                    )}
                  </div>
                </Accordion.Title>
                <Accordion.Content>
                  <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                    <div>
                      <p>
                        <strong>Provedor utilizado:</strong>{" "}
                        {providerNameById(item?.providerId)}{" "}
                        {item?.provedorReserva && "(reserva)"}
                      </p>
                    </div>

                    {Array.isArray(item?.errosAnteriores) &&
                      item.errosAnteriores.length > 0 && (
                        <div className="space-y-2">
                          <p className="font-semibold text-red-800">
                            Tentativas anteriores com erro:
                          </p>
                          {item.errosAnteriores.map((err, idx) => (
                            <div
                              key={idx}
                              className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                            >
                              <p>
                                <strong>Provedor:</strong>{" "}
                                {providerNameById(err?.providerId)}
                              </p>
                              <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                                {err?.message}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                    <div>
                      <p className="font-semibold">Dados retornados:</p>
                      <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                        {JSON.stringify(item, null, 2)}
                      </pre>
                    </div>
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            );
          })
          .filter(Boolean)
      : Object.entries(additional)
          .map(([key, item], i) => {
            if (!item) return null;
            return (
              <Accordion.Panel key={`add-obj-${i}`}>
                <Accordion.Title className="text-sm font-medium">
                  <div className="flex justify-between items-center w-full gap-2">
                    <span className="text-gray-800">
                      Adicional: {labelize(key)}
                    </span>
                    {item?.statusRetorno === 1 ? (
                      <Badge color="success" className="text-xs">
                        ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                      </Badge>
                    ) : (
                      <Badge color="failure" className="text-xs">
                        ❌ Falha
                      </Badge>
                    )}
                  </div>
                </Accordion.Title>
                <Accordion.Content>
                  <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                    <div>
                      <p>
                        <strong>Provedor utilizado:</strong>{" "}
                        {providerNameById(item?.providerId)}{" "}
                        {item?.provedorReserva && "(reserva)"}
                      </p>
                    </div>

                    {Array.isArray(item?.errosAnteriores) &&
                      item.errosAnteriores.length > 0 && (
                        <div className="space-y-2">
                          <p className="font-semibold text-red-800">
                            Tentativas anteriores com erro:
                          </p>
                          {item.errosAnteriores.map((err, idx) => (
                            <div
                              key={idx}
                              className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                            >
                              <p>
                                <strong>Provedor:</strong>{" "}
                                {providerNameById(err?.providerId)}
                              </p>
                              <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                                {err?.message}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                    <div>
                      <p className="font-semibold">Dados retornados:</p>
                      <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                        {JSON.stringify(item, null, 2)}
                      </pre>
                    </div>
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            );
          })
          .filter(Boolean);

    return { panelsMain: _panelsMain, panelsAdditional: _panelsAdditional };
  }, [queryDetails?.userQuery?.data, additional, providers]);

  const {
    isLoading: isLoadingCostBreakdown,
    error: errorCostBreakdown,
    data: costBreakdownItems,
  } = useQuery(
    ["costBreakdownByProtocol", protocolForCost],
    async () => {
      const { data } = await axios.get(ADMIN.GET_USER_QUERY_BY_PROTOCOL, {
        params: { protocol: protocolForCost },
      });
      return data?.data ?? data;
    },
    { enabled: openCostModal && !!protocolForCost }
  );

  const totalCostBreakdown = useMemo(() => {
    if (!Array.isArray(costBreakdownItems)) return 0;
    return costBreakdownItems.reduce(
      (sum, row) => sum + Number(row?.providerPrice || 0),
      0
    );
  }, [costBreakdownItems]);

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="bg-white text-slate-700 border border-slate-200 shadow-sm hover:bg-slate-50 transition-all duration-300 hover:text-white"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className="transition-transform duration-300">
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>

      <div className="flex flex-col gap-4">
        {showFilters && (
          <div className="bg-white border border-slate-200 rounded-xl shadow-sm transition-all duration-500 ease-in-out overflow-hidden">
            {(isLoadingCategories ||
              isLoadingQueryPermissions ||
              isLoadingQueries) && <DrawerLoading />}

            <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-slate-200 bg-gray-50">
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                Filtros Avançados
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-6 gap-3 px-3 py-3">
              {/* Produto */}
              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Produto
                </label>
                <div className="h-9">
                  <AutoCompleteInput
                    options={listQueries}
                    label=""
                    onChange={(product) => setSelectedProduct(product)}
                    value={selectedProduct?.value}
                    isLoading={isLoadingQueries}
                    className="h-full"
                  />
                </div>
                {errorQueries && (
                  <Alert color="failure" className="mt-2">
                    Ocorreu um erro ao buscar clientes
                  </Alert>
                )}
              </div>

              {/* Período */}
              <div className="flex flex-col md:col-span-4">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Período
                </label>
                <div className="flex gap-2 items-center h-12">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      if (moment(e.target.value).isAfter(moment(endDate))) {
                        setEndDate(e.target.value);
                      }
                    }}
                    className="w-full h-full bg-white border border-slate-300 text-xs rounded-md px-2.5 py-2 focus:ring-slate-500 focus:border-slate-500"
                  />
                  <span className="text-[11px] text-slate-500">até</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate}
                    className="w-full h-full bg-white border border-slate-300 text-xs rounded-md px-2.5 py-2 focus:ring-slate-500 focus:border-slate-500"
                  />
                </div>
              </div>

              {/* Status */}
              <div className="flex flex-col md:col-span-2 mt-3">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Status da Consulta
                </label>
                <div className="flex gap-2 h-9">
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(1, setSelectedStatuses)}
                    className={`h-full px-3 rounded-md text-xs font-semibold border transition w-full ${
                      selectedStatuses.includes(1)
                        ? "bg-emerald-600 text-white border-emerald-600 shadow-sm"
                        : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
                    }`}
                  >
                    Sucesso
                  </button>
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(0, setSelectedStatuses)}
                    className={`h-full px-3 rounded-md text-xs font-semibold border transition w-full ${
                      selectedStatuses.includes(0)
                        ? "bg-rose-600 text-white border-rose-600 shadow-sm"
                        : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
                    }`}
                  >
                    Falha
                  </button>
                </div>
              </div>

              {/* Usuário */}
              <div className="flex flex-col md:col-span-2 mt-3">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Usuário
                </label>
                <select
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                  className="w-full h-9 rounded-md border border-slate-300 bg-white text-xs text-slate-700 px-2.5"
                >
                  <option value="">Todos os usuários</option>
                  {(users || []).map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name} {u.email ? `— ${u.email}` : ""}
                    </option>
                  ))}
                </select>
              </div>

              {/* NOVO: Filtro "É adicional?" */}
              <div className="flex items-center justify-between gap-3 md:col-span-1 mt-6">
                <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2.5 py-1.5">
                  <input
                    id="filter-additional"
                    type="checkbox"
                    checked={filterIsAdditional}
                    onChange={(e) => setFilterIsAdditional(e.target.checked)}
                    className="w-4 h-4 text-slate-800 bg-slate-100 border-slate-300 rounded focus:ring-slate-500"
                  />
                  <span className="text-[11px] text-slate-600">
                    Somente consultas adicionais
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between gap-3 md:col-span-1 mt-6">
                <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2.5 py-1.5">
                  <input
                    id="filter-ia"
                    type="checkbox"
                    checked={filterHasIA}
                    onChange={(e) => setFilterHasIA(e.target.checked)}
                    className="w-4 h-4 text-slate-800 bg-slate-100 border-slate-300 rounded focus:ring-slate-500"
                  />
                  <span className="text-[11px] text-slate-600">
                    Somente consultas com IA
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className="flex-1 overflow-x-scroll print-padding print-content"
          ref={reportRef}
        >
          <div className="mt-3">
            <div className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 px-4 py-2 shadow-sm md:flex-row md:items-center md:justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 shadow-inner">
                  <BsFillBarChartFill className="text-xl" />
                </div>
                <p className="text-base font-semibold text-gray-900">
                  Resultado da busca
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2 justify-end text-xs">
                {hasActiveFilters ? (
                  <>
                    <span className="uppercase tracking-wide text-gray-500">
                      Filtros ativos
                    </span>
                    {appliedFilterSummary.slice(0, 4).map((item, index) => (
                      <span
                        key={`${item}-${index}`}
                        className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-medium border border-gray-200 shadow-sm"
                      >
                        {item}
                      </span>
                    ))}
                    {appliedFilterSummary.length > 4 && (
                      <span className="px-2 py-1 rounded-full bg-gray-50 text-gray-500 text-xs font-medium border border-dashed border-gray-300">
                        +{appliedFilterSummary.length - 4} oculto(s)
                      </span>
                    )}
                  </>
                ) : (
                  <span className="uppercase tracking-wide text-gray-500">
                    Nenhum filtro aplicado
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <div className="flex gap-4 pb-3 min-w-[800px]">
              {/* Valor Total */}
              <div className="min-w-[200px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Valor Total</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries ? (
                        formatToReal(totalPriceSum)
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-28" />
                      )}
                    </h2>
                  </div>
                  <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                </div>
              </div>

              {/* Total de Consultas */}
              <div className="min-w-[200px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#0F766E] to-[#14B8A6] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Total de Consultas</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries ? (
                        totalCount >= 1000 ? (
                          totalCount.toLocaleString("pt-BR")
                        ) : (
                          totalCount
                        )
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-24" />
                      )}
                    </h2>
                  </div>
                  <BsFillBarChartFill className="text-white text-4xl opacity-20" />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-4 mt-2 flex flex-col md:flex-row justify-between items-end md:items-center gap-2">
            <Button className="bg-gray-500" onClick={reactToPrintFn}>
              <div className="flex gap-2 items-center">
                <div>Imprimir</div>
              </div>
            </Button>
            <div className="flex gap-2 items-center">
              <div className="text-xs font-semibold">Visualizar relatório:</div>
              <ul className="text-sm rounded-md border border-gray-300 flex">
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 1
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(1)}
                >
                  Simplificado
                </li>
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 0
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(0)}
                >
                  Detalhado
                </li>
              </ul>
            </div>
          </div>

          {activeTab === 0 && (
            <form
              className="flex gap-1 mt-0 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
              onSubmit={handleSearchName}
            >
              <input
                type="text"
                placeholder="Busque por parâmetro da consulta..."
                className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
                onChange={(e) => setSearchName(e.target.value)}
                value={searchName}
              />
              <Button
                size="sm"
                className="flex items-center bg-secondary w-20"
                type="submit"
              >
                <IoMdSearch />
              </Button>
            </form>
          )}

          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>

          {/* ======== Detalhado ======== */}
          {activeTab === 0 && (
            <>
              {listReportQueries?.length > 0 || isLoadingReportQueries ? (
                <div className="mt-3 rounded-xl border border-gray-200 shadow-sm overflow-hidden bg-white">
                  <div className="flex items-center justify-between gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
                    <div className="text-sm font-semibold text-gray-800">
                      Relatório Detalhado
                    </div>
                  </div>

                  <div className="divide-y divide-gray-100">
                    {!isLoadingReportQueries ? (
                      listReportQueries?.map((query, index) => {
                        const created = moment(query.createdAt);
                        const statusOk = !!query.isSuccess;
                        const priceBase = Number(query?.priceBase || 0);
                        const priceFinal = Number(query?.price || 0);
                        const totalCostValue = Number(query?.totalCostPrice || 0);
                        const protocol = String(query?.protocol || "").trim();
                        const additionalLabel =
                          !query?.isAdditional && protocol
                            ? Array.from(
                                additionalByProtocol.get(protocol) || []
                              ).join(", ")
                            : "";
                        const marginPercent =
                          +totalCostValue > 0
                            ? -(1 - +priceBase / +totalCostValue) * 100
                            : null;

                        return (
                          <div
                            key={index}
                            className={[
                              "relative border-b border-gray-200 bg-white px-3 py-2 mb-0.5",
                              "shadow-sm transition-all hover:ring-1 hover:ring-gray-300",
                            ].join(" ")}
                          >
                            <span
                              className={[
                                "absolute left-0 top-0 h-full w-[3px]",
                                statusOk
                                  ? "bg-gradient-to-b from-emerald-500 to-emerald-600"
                                  : "bg-gradient-to-b from-rose-500 to-rose-600",
                              ].join(" ")}
                            />

                            <div className="hidden md:block">
                              <div className="flex items-start gap-3">
                                <div className="text-[10px] text-gray-500 flex flex-col gap-0.5 mt-1">
                                  <span className="font-semibold text-gray-700">
                                    {created.format("DD/MM/YY")}
                                  </span>
                                  <span>{created.format("HH:mm")}h</span>
                                </div>

                                <div className="flex-1 min-w-0 space-y-1">
                                  <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
                                    <span
                                      className="truncate"
                                      title={query.queryName}
                                    >
                                      {query.queryName}
                                    </span>
                                    {query?.hasIA ? (
                                      <span className="text-[10px] uppercase tracking-wide bg-blue-100 text-blue-700 rounded-full px-2 py-0.5">
                                        +IA
                                      </span>
                                    ) : null}
                                  </div>
                                  <div className="flex flex-wrap items-center gap-3 text-[11px] text-slate-500">
                                    {!!query?.protocol && (
                                      <span className="flex items-center gap-1">
                                        <span className="font-semibold text-gray-700">
                                          Protocolo:
                                        </span>
                                        <span>{query.protocol}</span>
                                      </span>
                                    )}
                                    <span className="flex items-center gap-1">
                                      <span className="font-semibold text-gray-700">
                                        Parâmetro:
                                      </span>
                                      <span>{query.parameter || "-"}</span>
                                    </span>
                                    {additionalLabel ? (
                                      <span className="flex items-center gap-1">
                                        <span className="font-semibold text-gray-700">
                                          Adicionais:
                                        </span>
                                        <span
                                          className="truncate max-w-[360px]"
                                          title={additionalLabel}
                                        >
                                          {additionalLabel}
                                        </span>
                                      </span>
                                    ) : null}
                                  </div>
                                </div>

                                <div className="flex flex-col items-end text-right text-[11px] text-gray-600 gap-1">
                                  <div className="flex items-baseline gap-3">
                                    {userPermission === "POWER_USER" && (
                                      <span className="font-semibold text-rose-600 text-[12px] mr-2">
                                        Vl. Custo (Relinq): {" "}
                                        {formatToReal(totalCostValue)}
                                      </span>
                                    )}

                                    <span
                                      className={`font-semibold text-[12px] ${
                                        userPermission === "POWER_USER"
                                          ? "text-gray-400"
                                          : "text-red-500"
                                      } ${
                                        userPermission === "POWER_USER"
                                          ? "ml-2"
                                          : ""
                                      }`}
                                    >
                                      {userPermission === "POWER_USER"
                                        ? "Vl. venda"
                                        : "Custo"}
                                      : {formatToReal(priceBase)}
                                    </span>
                                    <span className="font-semibold text-[12px] text-green-500">
                                      Vl. Final Venda: {" "}
                                      {formatToReal(priceFinal)}
                                    </span>
                                    {userPermission === "POWER_USER" && (
                                      <span
                                        className={`text-[12px] font-semibold ${
                                          marginPercent < 10
                                            ? "text-rose-600"
                                            : "text-emerald-600"
                                        }`}
                                      >
                                        (Margem: {" "}
                                        {marginPercent?.toFixed(1) || 0}%)
                                      </span>
                                    )}
                                  </div>
                                  <div className="flex flex-wrap gap-2 text-[12px] text-gray-500">
                                    <span className="max-w-[320px] truncate flex items-center gap-1">
                                      <MdPersonSearch size={13} />
                                      {query?.companyName || "-"}
                                    </span>
                                    <span className="max-w-[320px] truncate">
                                      <span className="font-semibold text-gray-700">
                                        Usuário:
                                      </span>{" "}
                                      {query.userName || "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="mt-2 flex items-center justify-between text-[11px] text-gray-500">
                                <div className="flex items-center gap-1">
                                  <span
                                    className={`flex items-center justify-center rounded-full text-[10px] px-2 py-0.5 font-semibold ${
                                      query.hasRestrictions
                                        ? "bg-rose-100 text-rose-700"
                                        : "bg-emerald-100 text-emerald-700"
                                    }`}
                                    title={
                                      query.hasRestrictions
                                        ? "Com restrição"
                                        : "Sem restrição"
                                    }
                                  >
                                    {query.hasRestrictions ? (
                                      <div className="flex items-center gap-1">
                                        <MdErrorOutline size={12} />
                                        <span>Documento com Restrições</span>
                                      </div>
                                    ) : (
                                      <div className="flex items-center gap-1">
                                        <IoIosCheckmarkCircleOutline size={12} />
                                        <span>Documento sem Restrições</span>
                                      </div>
                                    )}
                                  </span>
                                  {additionalLabel ? (
                                    <span
                                      className="flex items-center rounded-full text-[10px] px-2 py-0.5 font-semibold bg-amber-100 text-amber-700 max-w-[320px] truncate"
                                      title={additionalLabel}
                                    >
                                      Adicionais: {additionalLabel}
                                    </span>
                                  ) : null}
                                </div>

                                <div className="flex items-center gap-1 text-gray-600">
                                  {!!query?.isSuccess && !query.isModular && (
                                    <button
                                      type="button"
                                      className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                      title="Visualizar consulta"
                                      onClick={() => {
                                        setSelectedQueryReview(query);
                                        setDataQuery(query.data);
                                        setOpenModal(true);
                                      }}
                                    >
                                      <MdOutlinePageview fontSize={16} />
                                    </button>
                                  )}
                                  {userPermission === "POWER_USER" && (
                                    <>
                                      {!!query?.protocol && (
                                        <button
                                          type="button"
                                          className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                          title="Detalhar custo (protocolo)"
                                          onClick={() => {
                                            setProtocolForCost(query.protocol);
                                            setOpenCostModal(true);
                                          }}
                                        >
                                          <MdReceiptLong fontSize={16} />
                                        </button>
                                      )}
                                      <button
                                        type="button"
                                        className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                        title="Detalhes técnicos"
                                        onClick={() => {
                                          setSelectedQuery(query);
                                          setOpenModalViewDetails(true);
                                        }}
                                      >
                                        <MdOutlineDisplaySettings fontSize={16} />
                                      </button>
                                      <button
                                        type="button"
                                        className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                        title="Editar preço"
                                        onClick={() => {
                                          setQueryToEdit(query);
                                          setNewPrice(query?.price || "");
                                          setEditPriceModalOpen(true);
                                        }}
                                      >
                                        <MdEdit fontSize={16} />
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="md:hidden space-y-2">
                              <div className="flex items-start justify-between gap-2">
                                <div className="min-w-0">
                                  <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
                                    <span
                                      className="truncate"
                                      title={query.queryName}
                                    >
                                      {query.queryName}
                                    </span>
                                    {query?.hasIA ? (
                                      <span className="text-[10px] uppercase tracking-wide bg-blue-100 text-blue-700 rounded-full px-2 py-0.5">
                                        +IA
                                      </span>
                                    ) : null}
                                  </div>
                                  <div className="mt-0.5 text-[11px] text-gray-500 flex flex-wrap items-center gap-2">
                                    <span className="font-semibold text-gray-700">
                                      {created.format("DD/MM/YY")}
                                    </span>
                                    <span>{created.format("HH:mm")}h</span>
                                    <span className="text-gray-300">•</span>
                                    <span className="truncate">
                                      {query.parameter || "-"}
                                    </span>
                                  </div>
                                  {additionalLabel ? (
                                    <div className="mt-1 text-[11px] text-slate-500">
                                      <span className="font-semibold text-gray-700">
                                        Adicionais:
                                      </span>{" "}
                                      <span className="truncate">
                                        {additionalLabel}
                                      </span>
                                    </div>
                                  ) : null}
                                </div>
                                <span
                                  className={`flex items-center justify-center rounded-full text-[10px] px-2 py-0.5 font-semibold ${
                                    query.hasRestrictions
                                      ? "bg-rose-100 text-rose-700"
                                      : "bg-emerald-100 text-emerald-700"
                                  }`}
                                  title={
                                    query.hasRestrictions
                                      ? "Com restrição"
                                      : "Sem restrição"
                                  }
                                >
                                  {query.hasRestrictions ? (
                                    <div className="flex items-center gap-1">
                                      <MdErrorOutline size={12} />
                                      <span>Restrições</span>
                                    </div>
                                  ) : (
                                    <div className="flex items-center gap-1">
                                      <IoIosCheckmarkCircleOutline size={12} />
                                      <span>Sem restrições</span>
                                    </div>
                                  )}
                                </span>
                              </div>

                              <div className="flex flex-wrap gap-2 text-[11px] text-gray-600">
                                {!!query?.protocol && (
                                  <span className="flex items-center gap-1">
                                    <span className="font-semibold text-gray-700">
                                      Protocolo:
                                    </span>
                                    <span>{query.protocol}</span>
                                  </span>
                                )}
                                <span className="flex items-center gap-1">
                                  <MdPersonSearch size={12} />
                                  <span className="truncate max-w-[220px]">
                                    {query?.companyName || "-"}
                                  </span>
                                </span>
                                <span className="flex items-center gap-1">
                                  <span className="font-semibold text-gray-700">
                                    Usuário:
                                  </span>
                                  <span className="truncate max-w-[200px]">
                                    {query.userName || "-"}
                                  </span>
                                </span>
                              </div>

                              <div className="flex flex-wrap gap-2 text-[11px]">
                                {userPermission === "POWER_USER" && (
                                  <span className="font-semibold text-rose-600">
                                    Vl. Custo: {formatToReal(totalCostValue)}
                                  </span>
                                )}
                                <span
                                  className={`font-semibold ${
                                    userPermission === "POWER_USER"
                                      ? "text-gray-500"
                                      : "text-red-500"
                                  }`}
                                >
                                  {userPermission === "POWER_USER"
                                    ? "Vl. venda"
                                    : "Custo"}
                                  : {formatToReal(priceBase)}
                                </span>
                                <span className="font-semibold text-green-600">
                                  Vl. Final: {formatToReal(priceFinal)}
                                </span>
                                {userPermission === "POWER_USER" && (
                                  <span
                                    className={`font-semibold ${
                                      marginPercent < 10
                                        ? "text-rose-600"
                                        : "text-emerald-600"
                                    }`}
                                  >
                                    Margem: {marginPercent?.toFixed(1) || 0}%
                                  </span>
                                )}
                              </div>

                              <div className="flex items-center justify-end gap-1 text-gray-600">
                                {!!query?.isSuccess && !query.isModular && (
                                  <button
                                    type="button"
                                    className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                    title="Visualizar consulta"
                                    onClick={() => {
                                      setSelectedQueryReview(query);
                                      setDataQuery(query.data);
                                      setOpenModal(true);
                                    }}
                                  >
                                    <MdOutlinePageview fontSize={16} />
                                  </button>
                                )}
                                {userPermission === "POWER_USER" && (
                                  <>
                                    {!!query?.protocol && (
                                      <button
                                        type="button"
                                        className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                        title="Detalhar custo (protocolo)"
                                        onClick={() => {
                                          setProtocolForCost(query.protocol);
                                          setOpenCostModal(true);
                                        }}
                                      >
                                        <MdReceiptLong fontSize={16} />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                      title="Detalhes técnicos"
                                      onClick={() => {
                                        setSelectedQuery(query);
                                        setOpenModalViewDetails(true);
                                      }}
                                    >
                                      <MdOutlineDisplaySettings fontSize={16} />
                                    </button>
                                    <button
                                      type="button"
                                      className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                      title="Editar preço"
                                      onClick={() => {
                                        setQueryToEdit(query);
                                        setNewPrice(query?.price || "");
                                        setEditPriceModalOpen(true);
                                      }}
                                    >
                                      <MdEdit fontSize={16} />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div>
                        <div className="p-1 space-y-2">
                          {Array.from({ length: 16 }).map((_, i) => (
                            <div
                              key={i}
                              className="relative px-2.5 py-1.5 rounded-lg mx-1 my-[3px] ring-1 ring-transparent"
                            >
                              <span className="absolute left-0 top-0 h-full w-[3px] bg-gray-200 rounded-l-lg" />
                              <div className="flex items-center gap-2">
                                <div className="shrink-0">
                                  <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="min-w-0 flex-1">
                                  <div className="h-4 w-2/3 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="shrink-0 flex items-center gap-2">
                                  <div className="h-5 w-24 bg-gray-200 rounded-full animate-pulse" />
                                  <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="w-[82px] shrink-0">
                                  <div className="h-5 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="shrink-0 flex items-center gap-1">
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

          {/* ======== Simplificado ======== */}
          {activeTab === 1 && (
            <>
              {listReportSimplifiedQueries?.length > 0 ||
              isLoadingReportSimplifiedQueries ? (
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm mt-3">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-3">
                    <div className="text-sm font-semibold text-gray-800">
                      {filterIsAdditional
                        ? "Distribuição por adicional"
                        : "Distribuição por consulta"}
                    </div>

                    {/* Botões: count | value */}
                    <div className="inline-flex rounded-md overflow-hidden border border-gray-300">
                      <button
                        type="button"
                        onClick={() => setBarMetric("count")}
                        className={`px-2.5 py-1 text-xs ${
                          barMetric === "count"
                            ? "bg-blue-800 text-white"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        Por quantidade
                      </button>
                      <button
                        type="button"
                        onClick={() => setBarMetric("value")}
                        className={`px-2.5 py-1 text-xs ${
                          barMetric === "value"
                            ? "bg-blue-800 text-white"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        Por valor
                      </button>
                    </div>
                  </div>

                  <div className="p-3">
                    {!isLoadingReportSimplifiedQueries ? (
                      (() => {
                        const denomCount = Number(totalCount) || 0;
                        const denomValue = Number(totalPriceSum) || 0;

                        const rows = [...(listReportSimplifiedQueries || [])].sort(
                          (a, b) => {
                            const av =
                              barMetric === "value"
                                ? Number(a.totalPrice || 0)
                                : Number(a.count || 0);
                            const bv =
                              barMetric === "value"
                                ? Number(b.totalPrice || 0)
                                : Number(b.count || 0);
                            return bv - av;
                          }
                        );

                        return (
                          <div className="divide-y divide-gray-200">
                            {rows.map((q, idx) => {
                              const count = Number(q.count) || 0;
                              const value = Number(q.totalPrice || 0) || 0;

                              const percent =
                                barMetric === "value"
                                  ? denomValue > 0
                                    ? (value / denomValue) * 100
                                    : 0
                                  : denomCount > 0
                                  ? (count / denomCount) * 100
                                  : 0;

                              const displayName = filterIsAdditional
                                ? q.additionalName || q.queryName
                                : q.queryName;

                              const subtitle = filterIsAdditional
                                ? "Adicional"
                                : "Consulta";

                              return (
                                <div
                                  key={idx}
                                  className={`px-2 py-1 ${
                                    (idx + 1) % 2 === 0
                                      ? "bg-gray-50"
                                      : "bg-white"
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="w-8 text-[11px] font-semibold text-gray-400">
                                      #{idx + 1}
                                    </div>
                                    <div className="flex-1 min-w-0 flex items-center gap-2">
                                      <span className="text-[10px] font-semibold text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded-full">
                                        {subtitle}
                                      </span>
                                      <span className="text-[10px] font-semibold text-gray-700 bg-gray-100 border border-gray-200 px-1.5 py-0.5 rounded-full">
                                        {percent.toFixed(1)}%
                                      </span>
                                      <div
                                        className="text-[13px] font-semibold text-gray-900 truncate"
                                        title={displayName}
                                      >
                                        {displayName}
                                      </div>
                                    </div>
                                    <div className="shrink-0 flex items-center gap-2 text-[11px] whitespace-nowrap">
                                      <div className="flex items-center gap-1">
                                        <span className="text-gray-500 text-[10px] uppercase tracking-wide">
                                          Qtd
                                        </span>
                                        <span className="font-semibold text-blue-700">
                                          {count >= 1000
                                            ? count.toLocaleString("pt-BR")
                                            : count}
                                        </span>
                                      </div>
                                      <span className="text-gray-300">•</span>
                                      <div className="flex items-center gap-1">
                                        <span className="text-gray-500 text-[10px] uppercase tracking-wide">
                                          Valor
                                        </span>
                                        <span className="font-semibold text-green-700">
                                          {formatToReal(value)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })()
                    ) : (
                      Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="p-3 animate-pulse">
                          <div className="flex items-center justify-between">
                            <div className="h-3.5 bg-gray-200 rounded w-2/3" />
                            <div className="flex gap-3">
                              <div className="h-3.5 bg-gray-200 rounded w-8" />
                              <div className="h-3.5 bg-gray-200 rounded w-16" />
                            </div>
                          </div>
                          <div className="h-2 bg-gray-200 rounded-full mt-2" />
                        </div>
                      ))
                    )}
                  </div>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

        </div>

        {totalPages > 1 && (
          <div className="flex overflow-x-auto justify-center mt-3">
            <Pagination
              layout="pagination"
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              previousLabel=""
              nextLabel=""
              showIcons
            />
          </div>
        )}

        <Modal
          show={openModalViewDetails}
          size="3xl"
          onClose={() => setOpenModalViewDetails(false)}
          popup
          className="relative"
        >
          <Modal.Header />
          <Modal.Body>
            <Tabs
              aria-label="Tabs de Detalhes"
              onActiveTabChange={(tabIndex) => setActiveTabModal(tabIndex)}
            >
              <TabItem active={activeTabModal === 0} title="Informações">
                <div className="space-y-6">
                  <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">
                      Resumo da Consulta
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
                      <Info label="Consulta" value={selectedQuery?.queryName} />
                      <Info
                        label="Data e Hora"
                        value={
                          moment(selectedQuery?.createdAt).format(
                            "DD/MM/yyyy | HH:mm"
                          ) + "h"
                        }
                      />
                      <Info
                        label="IP"
                        value={queryDetails?.userQuery?.ip || "-"}
                      />
                      <Info
                        label="Parâmetro Informado"
                        value={selectedQuery?.parameter}
                      />
                      <Info
                        label="Quadro de Avisos"
                        value={
                          selectedQuery?.QueryCustomized?.showAlertsBoard
                            ? "Sim"
                            : "Não"
                        }
                      />
                      <Info label="Usuário" value={selectedQuery?.userName} />
                      <Info
                        label="Preço"
                        value={formatToReal(selectedQuery?.price || 0)}
                      />
                      <div className="flex items-center gap-2">
                        <span className="font-semibold">Status:</span>
                        {selectedQuery?.isSuccess ? (
                          <Badge color="success">✅ Sucesso</Badge>
                        ) : (
                          <Badge color="failure">❌ Falha</Badge>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </TabItem>

              <TabItem active={activeTabModal === 1} title="Status">
                <div className="max-h-[500px] overflow-y-auto space-y-3 px-1">
                  {queryDetails?.userQuery?.data ? (
                    <Accordion collapseAll>
                      {panelsMain}
                      {panelsAdditional}
                    </Accordion>
                  ) : (
                    <p className="text-sm text-center text-gray-500 py-4">
                      Nenhum log encontrado.
                    </p>
                  )}
                </div>
              </TabItem>
            </Tabs>
          </Modal.Body>
          {isLoadingQueryDetails && <DrawerLoading />}
        </Modal>

        <Modal show={openModal} onClose={handleCloseReviewModal} size="6xl">
          <ModalHeader className="py-2">
            <span className="text-base mt-1">Visualizar consulta</span>
          </ModalHeader>
          <ModalBody className="bg-gray-100">
            {!isOlderThan30Days(selectedQueryReview?.createdAt) ? (
              <>
                <div className="review-query" ref={printRef}>
                  {selectedQueryReview?.categoryId === 1 && (
                    <CustomCreditQueryReview
                      key={`credit-${selectedQueryReview?.id || "none"}`}
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 2 && (
                    <CustomCadastralQueryReview
                      key={`cadastral-${selectedQueryReview?.id || "none"}`}
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 3 && (
                    <CustomVehicleQueryReview
                      key={`vehicle-${selectedQueryReview?.id || "none"}`}
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                </div>
              </>
            ) : (
              <div className="bg-gray-50 p-2 rounded-md border border-gray-300 rounded-md">
                A consulta não está mais disponível para visualização em nossa
                base de dados, possivelmente por ter ultrapassado o período de
                retenção (7 dias) ou por políticas de conformidade. Se precisar
                reavaliar, recomendamos gerar uma nova consulta.
              </div>
            )}
          </ModalBody>
          <ModalFooter className="flex justify-center py-2 pb-3">
            <Button onClick={() => reactToPrintFnQuery()}>Imprimir</Button>
            <Button color="gray" onClick={handleCloseReviewModal}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>

        <ModalEditPrice
          isOpen={editPriceModalOpen}
          initialPrice={queryToEdit?.price}
          onClose={() => {
            setEditPriceModalOpen(false);
            setQueryToEdit(null);
          }}
          onSave={async (parsedPrice) => {
            await axios.put(`${ADMIN.UPDATE_QUERY_PRICE}/${queryToEdit?.id}`, {
              price: parsedPrice,
            });
            queryClient.invalidateQueries("listReportQueries");
            setEditPriceModalOpen(false);
            setQueryToEdit(null);
          }}
        />

        <Modal
          show={openCostModal}
          onClose={() => {
            setOpenCostModal(false);
            setProtocolForCost(null);
          }}
          size="2xl"
          popup
        >
          <ModalHeader className="px-4 mb-4">
            Detalhe de custo da consulta
          </ModalHeader>
          <ModalBody>
            {isLoadingCostBreakdown ? (
              <div className="flex items-center justify-center py-8">
                <Spinner />
              </div>
            ) : errorCostBreakdown ? (
              <Alert color="failure">
                Ocorreu um erro ao carregar o detalhamento de custos.
              </Alert>
            ) : Array.isArray(costBreakdownItems) &&
              costBreakdownItems.length > 0 ? (
              <div className="space-y-3">
                <div className="rounded-xl border border-gray-200 overflow-hidden">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell className="bg-gray-100">
                        Módulo
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-100">
                        Custo
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                      {costBreakdownItems.map((row, idx) => (
                        <Table.Row key={idx} className="bg-white">
                          <Table.Cell className="font-medium">
                            {row?.name || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center">
                            {formatToReal(row?.providerPrice || 0)}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>

                <div className="flex justify-center">
                  <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 bg-gray-100 border border-gray-200">
                    <span className="text-xs text-gray-600">
                      Total de custo
                    </span>
                    <span className="text-sm font-semibold">
                      {formatToReal(totalCostBreakdown)}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <EmptyTable icon="search_off">
                Nenhum item encontrado para este protocolo.
              </EmptyTable>
            )}
          </ModalBody>
          <ModalFooter className="flex justify-center">
            <Button color="gray" onClick={() => setOpenCostModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default AdminHistoryTableSpecific;
